const visibleStart = 4; // Number of digits to display at the beginning of the phone number or email's local part.
const visibleEnd = 4; // Number of digits to display at the end of the phone number or email's local part.

export const concealPhoneNumber = (number) => {
  // Replace country code "234" with "0".
  const phoneNumber = number.startsWith("234")
    ? number.replace("234", "0")
    : number;

  if (phoneNumber.length <= visibleStart + visibleEnd) {
    // If the phone number is too short to conceal, return the original phone number.
    return phoneNumber;
  }

  const concealedNumber =
    phoneNumber.slice(0, visibleStart) +
    "*".repeat(phoneNumber.length - visibleStart - visibleEnd) +
    phoneNumber.slice(-visibleEnd);

  return concealedNumber;
};

export const concealEmail = (email) => {
  const [localPart, domain] = email.split("@");

  if (!domain) {
    // If the email format is incorrect, return the original email.
    return email;
  }

  const visiblePart = localPart.slice(0, 2);
  const concealedEmail =
    visiblePart +
    "*".repeat(Math.max(localPart.length - visiblePart.length, 0)) +
    "@" +
    domain;

  return concealedEmail;
};
